import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";

const getBaseURL = () => {
    // In browser, use the current origin
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    
    // Fallback for SSR/build time
    return import.meta.env.VITE_TRPC_SERVER_URL || 'http://localhost:8000';
};

export const authClient = createAuthClient({
    baseURL: getBaseURL(), // This should point to your backend
    plugins: [
        twoFactorClient({
            onTwoFactorRedirect() {
                // Handle 2FA redirect - this will be called when 2FA is required
                console.log("2FA verification required");
                window.location.href = "/login";
            },
        }),
    ],
});

export const { signIn, signOut, signUp, useSession } = authClient;
